module.exports = __webpack_public_path__ + "static/media/agricultural13.594dd671.jpg";